import axiosClient from './axiosClient';

const payoutService = {
    adminGetAllPayouts: async (params) => {
        const response = await axiosClient.get(`/admin/payouts`, { params });
        return response.data;
    },

    adminGetPayout: async (payoutId) => {
        const response = await axiosClient.get(`/admin/payouts/${payoutId}`);
        return response.data;
    },

    adminCompletePayout: async (payoutId) => {
        const response = await axiosClient.put(`/admin/payouts/${payoutId}/complete`);
        return response.data;
    },

    adminRejectPayout: async (payoutId, reason) => {
        const response = await axiosClient.put(`/admin/payouts/${payoutId}/reject`, { reason });
        return response.data;
    },

    adminRequestPayout: async (payload) => {
        const response = await axiosClient.post(`/admin/payouts/request`, payload);
        return response.data;
    },

    vendorRequestPayout: async (payload) => {
        console.log('Requesting payout with payload:', payload);
        const response = await axiosClient.post(`/vendor/payouts/request`, payload);
        return response.data;
    },

    //  get my payouts as logged in vendor
    getVendorPayouts: async (params) => {
        const response = await axiosClient.get(`/vendor/payouts`, { params });
        return response.data;
    }
};

export default payoutService;
